import { render, staticRenderFns } from "./DrOperador.vue?vue&type=template&id=2c218d4e&"
import script from "./DrOperador.vue?vue&type=script&lang=js&"
export * from "./DrOperador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports